import { useQuery } from '@tanstack/react-query';
import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { siteQuery } from '../api.ts';
import { ErrorNotice, Loading } from '../common.tsx';
import { Route as parent } from './site.tsx';
const Screen = lazy(async () => ({ default: (await import('../components/page-editor.tsx')).PageEditor }));
export const Route = createRoute({
  getParentRoute: () => parent,
  path: 'pages/$pageId',
  component: RouteComponent,
});
function RouteComponent() {
  const { siteId, pageId } = Route.useParams();
  const site = useQuery(siteQuery(siteId, { includePages: true }));
  if (site.isPending) return <Loading />;
  if (site.error) return <ErrorNotice error={site.error} />;
  const snapshot = site.data!;
  return (
    <Suspense fallback={<Loading />}>
      <Screen key={pageId} objectId={pageId} snapshot={snapshot} />
    </Suspense>
  );
}
